import { useGqlSearchChatRoomsByNameQuery } from 'generated/graphql'

interface IFProps {
  chatRoomName: string
}

const useGetExamChatRoomId = ({ chatRoomName }: IFProps): string => {
  const { data, loading, error } = useGqlSearchChatRoomsByNameQuery({
    variables: {
      name: chatRoomName,
    },
  })

  if (loading || error) {
    return ''
  }

  return data?.searchChatRoomsByName?.nodes[0]?.id || ''
}

export default useGetExamChatRoomId
